import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "qualitaTaskTd" };
const _hoisted_2 = { class: "d-flex align-items-center" };
const _hoisted_3 = { class: "qualitaTaskTd" };
const _hoisted_4 = { class: "d-flex align-items-center" };
const _hoisted_5 = { class: "qualitaTaskTd" };
const _hoisted_6 = { class: "d-flex align-items-center" };
const _hoisted_7 = { class: "qualitaTaskTd" };
const _hoisted_8 = { class: "d-flex align-items-center" };
const _hoisted_9 = {
    key: 0,
    class: "d-flex align-items-center mt-1"
};
const _hoisted_10 = {
    key: 1,
    class: "d-flex align-items-center mt-1"
};
const _hoisted_11 = ["readonly"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_toggler = _resolveComponent("toggler");
    return (_openBlock(), _createElementBlock("table", {
        class: _normalizeClass(["table table-fixed", { glow: _ctx.newStato == 'In modifica' }])
    }, [
        _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_toggler, {
                            class: "mr-1",
                            disabled: _ctx.newStato != 'In modifica',
                            modelValue: _ctx.task.qualitaTask.erroreLeggero,
                            "onUpdate:modelValue": [
                                _cache[0] || (_cache[0] = ($event) => ((_ctx.task.qualitaTask.erroreLeggero) = $event)),
                                _cache[1] || (_cache[1] = ($event) => (_ctx.checkThisOnly('erroreLeggero')))
                            ]
                        }, null, 8, ["disabled", "modelValue"]),
                        _cache[9] || (_cache[9] = _createElementVNode("span", null, "Errore leggero", -1))
                    ])
                ]),
                _createElementVNode("td", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_toggler, {
                            class: "mr-1",
                            disabled: _ctx.newStato != 'In modifica',
                            modelValue: _ctx.task.qualitaTask.erroreGrave,
                            "onUpdate:modelValue": [
                                _cache[2] || (_cache[2] = ($event) => ((_ctx.task.qualitaTask.erroreGrave) = $event)),
                                _cache[3] || (_cache[3] = ($event) => (_ctx.checkThisOnly('erroreGrave')))
                            ]
                        }, null, 8, ["disabled", "modelValue"]),
                        _cache[10] || (_cache[10] = _createElementVNode("span", null, "Errore grave", -1))
                    ])
                ]),
                _createElementVNode("td", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_toggler, {
                            class: "mr-1",
                            disabled: _ctx.newStato != 'In modifica',
                            modelValue: _ctx.task.qualitaTask.erroreDoppio,
                            "onUpdate:modelValue": [
                                _cache[4] || (_cache[4] = ($event) => ((_ctx.task.qualitaTask.erroreDoppio) = $event)),
                                _cache[5] || (_cache[5] = ($event) => (_ctx.checkThisOnly('erroreDoppio')))
                            ]
                        }, null, 8, ["disabled", "modelValue"]),
                        _cache[11] || (_cache[11] = _createElementVNode("span", null, "Errore doppio", -1))
                    ])
                ]),
                _createElementVNode("td", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_toggler, {
                            class: "mr-1",
                            disabled: _ctx.newStato != 'In modifica',
                            modelValue: _ctx.task.qualitaTask.erroreCliente,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.task.qualitaTask.erroreCliente) = $event))
                        }, null, 8, ["disabled", "modelValue"]),
                        _cache[12] || (_cache[12] = _createElementVNode("span", null, "Errore cliente", -1))
                    ]),
                    (_ctx.task.qualitaTask.erroreCliente)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createVNode(_component_toggler, {
                                class: "mr-1",
                                disabled: _ctx.newStato != 'In modifica',
                                modelValue: _ctx.task.qualitaTask.hasExtraCompenso,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.task.qualitaTask.hasExtraCompenso) = $event))
                            }, null, 8, ["disabled", "modelValue"]),
                            _cache[13] || (_cache[13] = _createElementVNode("span", null, "Extra compenso", -1))
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.task.qualitaTask.hasExtraCompenso)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _cache[14] || (_cache[14] = _createElementVNode("span", null, "Importo extra compenso", -1)),
                            _withDirectives(_createElementVNode("input", {
                                type: "number",
                                class: "form-control",
                                readonly: _ctx.newStato != 'In modifica',
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.task.qualitaTask.extraCompensoAmount) = $event))
                            }, null, 8, _hoisted_11), [
                                [_vModelText, _ctx.task.qualitaTask.extraCompensoAmount]
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ])
            ])
        ])
    ], 2));
}
